import { Component, OnInit, Input } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-photo-gallery",
  templateUrl: "./photo-gallery.component.html",
  styleUrls: ["./photo-gallery.component.css"],
})
export class PhotoGalleryComponent implements OnInit {
  slides: any[] = [];
  @Input() settings: any;

  constructor(private sanitizer: DomSanitizer) {
    this.getFancybox();
  }

  getSafeLinks() {
    if (this.settings.ImageLink && this.settings.ImageLink.length > 0) {
     
      this.settings.ImageLink.forEach((element) => {
        element.url = this.sanitizer.bypassSecurityTrustResourceUrl(
          element.url
        );
        if (element.videoThumb) {
          element.videoThumb = this.sanitizer.bypassSecurityTrustResourceUrl(
            element.videoThumb
          );
        }
        this.slides.push(element);
      });
      if ((this.slides = this.settings.ImageLink && this.settings.ImageLink.length ? this.settings.ImageLink : [])) {
        this.slides.sort(
          this.compareValues("creationDate", this.settings.orderType)
        );
      }
    }
  }

  ngOnInit() {
     this.getSafeLinks();
  }

  getSafeUrl(item) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(item);
  }

  getFancybox() {
    const oldLinks = document.getElementsByTagName("link");
    const oldJs = document.getElementsByTagName("script");
    for (let index = 0; index < oldLinks.length; index++) {
      const element = oldLinks[index];
      const getName = element.getAttribute("name");
      if (getName && getName.indexOf("facnyCSS") !== -1) {
        document.head.removeChild(element);
        index = index - 1;
      }
    }
    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      const getName = element.getAttribute("name");
      if (getName && getName.indexOf("facnyJS") !== -1) {
        document.body.removeChild(element);
        index = index - 1;
      }
    }

    var css =
      "https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.css";
    var js =
      "https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.min.js";

    const facnyCSS = document.createElement("link");
    facnyCSS.setAttribute("rel", "stylesheet");
    facnyCSS.setAttribute("type", "text/css");
    facnyCSS.setAttribute("name", "facnyCSS");
    facnyCSS.setAttribute("href", css);
    document.head.appendChild(facnyCSS);

    const facnyJS = document.createElement("script");
    facnyJS.setAttribute("name", "facnyJS");
    facnyJS.setAttribute("src", js);
    document.body.appendChild(facnyJS);
  }
  
  public compareValues(key: string | number, order = "") {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
      }

      const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
      const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return order === "-" ? comparison * -1 : comparison;
    };
  }
}
